import { Image } from '../../../components/image/Image';
import { ClassNames } from '../../../interfaces';
import { classes } from '../../../utils/commonUtils';
import css from './background-header.module.scss';

interface BackgroundHeaderProps {
  image: string;
  title?: string | JSX.Element;
  classNames?: ClassNames<'container' | 'overlay' | 'image' | 'title'>;
}

export function BackgroundHeader({ image, title, classNames }: BackgroundHeaderProps) {
  return (
    <header className={classes(css.container, classNames?.container)}>
      <div className={classes(css.overlay, classNames?.overlay)} />
      <Image className={classes(css.image, classNames?.image)} src={image} alt="" />
      {title !== undefined && <BackgroundHeaderTitle title={title} className={classNames?.title} />}
    </header>
  );
}

interface BackgroundHeaderTitleProps {
  title: string | JSX.Element;
  className?: string;
}

function BackgroundHeaderTitle({ title, className }: BackgroundHeaderTitleProps) {
  if (typeof title === 'string') {
    return <h1 className={classes(css.title, className)}>{title}</h1>;
  }

  return <span className={classes(css.title, className)}>{title}</span>;
}
